import { 
    FaCalendarDay, 
    FaEdit, 
    FaChartBar, 
    FaBolt, 
    FaListUl, 
    FaColumns, 
    FaHome, 
    FaCog, 
    FaFlag, 
    FaCalendarTimes,
    FaCalendarCheck,
    FaCalendarPlus, 
    FaTimes, 
    FaSortAlphaUp,
    FaTags
} from 'react-icons/fa'
import React from 'react';
import _ from 'lodash'
import moment from 'moment-timezone'
import { getPlainText } from 'utils'

export const userContext = {
    PLANS: {
        PERSONAL: 'PERSONAL',
        PREMIUM: 'PREMIUM',
        TEAM: 'TEAM',
        BETA: 'BETA'
    },
    LIMITS: {
        ITEM: 1000,
        PAGE: 5
    }
}

export const accessContext = {
    HISTORY: {
        title: 'History',
        value: 'HISTORY',
        active: true,
        icon: <FaChartBar/>,
        width: '30rem'
    },
    CALENDAR: {
        title: 'Calendar',
        value: 'CALENDAR',
        active: true,
        icon: <FaCalendarDay/>,
        width: {
            day: '30rem',
            week: '60rem',
            month: '60rem'
        }
    },
    NOTES: {
        title: 'Notes',
        value: 'NOTES',
        active: false,
        icon: <FaEdit/>,
        width: '30rem'
    }
}
export const moduleContext = {
    ACCESS_MODULES: {
        NOTES: 'Notes',
        HISTORY: 'History',
        CALENDAR: 'Calendar',
    },
    MODULES: {
        NOTES: 'Notes',
        HISTORY: 'History',
        CALENDAR: 'Calendar',
        INTEGRATIONS: 'Integrations',
        HOME: 'Home',
        SETTINGS: 'Settings'
    },
    ICONS : {
        NOTES: <FaEdit/>,
        HISTORY: <FaChartBar/>,
        CALENDAR: <FaCalendarDay/>,
        INTEGRATIONS: <FaBolt/>,
        HOME: <FaHome/>,
        SETTINGS: <FaCog/>
    },
    WIDTHS: {
        NOTES: '30rem',
        // FOCUS: '50rem',
        HISTORY: '30rem',
        CALENDAR: '30rem',
    },
    ACCESS: {
        PAGES: ['NOTES','HISTORY','CALENDAR'],
        MODULES: {
            HOME: ['HISTORY','CALENDAR'],
            CALENDAR: ['HISTORY','CALENDAR'],
            INTEGRATIONS: ['HISTORY','CALENDAR'],
            SANDBOX: ['NOTES','HISTORY','CALENDAR'],
        }
    }
}

export const pageContext = {
    TYPES: {
        PAGES: 'Pages',
        MODULES: 'Modules'
    },
    STATUS: {
        ACTIVE: 'ACTIVE',
        ARCHIVE: 'ARCHIVE'
    },
    MODULES: {
        HOME: 'HOME',
        INBOX: 'INBOX',
        CALENDAR: 'CALENDAR',
        SETTINGS: 'SETTINGS',
        // FOCUS: 'FOCUS',
        // TEST: 'TEST',
        SANDBOX: 'SANDBOX',
        INTEGRATIONS: 'INTEGRATIONS'
    },
    VIEWS: {
        LIST_VIEW: 'LIST_VIEW',
        KANBAN_VIEW: 'KANBAN_VIEW',
        CALENDAR_VIEW: 'CALENDAR_VIEW'
    },
    ICONS: {
        LIST_VIEW: <FaListUl/>,
        KANBAN_VIEW: <FaColumns/>
    },
    VIEW_OPTIONS: {
        LIST_VIEW: 'List',
        KANBAN_VIEW: 'Kanban',
        // CALENDAR_VIEW: 'Calendar'
    }
}

export const sectionContext = {
    STATUS: {
        ACTIVE: 'ACTIVE',
        ARCHIVE: 'ARCHIVE'
    }
}

export const itemContext = {
    STATUS: {
        COMPLETED: 'COMPLETED',
        INCOMPLETE: 'INCOMPLETE'
    },
    PRIORITY: {
        // HIGH: 'High',
        // MEDIUM: 'Medium',
        // LOW: 'Low',
        // NONE: 'None',
        HIGH: 'HIGH',
        MEDIUM: 'MEDIUM',
        LOW: 'LOW',
        NONE: 'NONE',
    },
    PRIORITY_TITLE: {
        HIGH: 'High',
        MEDIUM: 'Medium',
        LOW: 'Low',
        NONE: 'None',
    },
    PRIORITY_COLOR: {
        NONE: 'var(--secondary-accent-color)',
        HIGH: 'var(--category-one-color)',
        MEDIUM: 'var(--category-two-color)',
        LOW: 'var(--category-three-color)'
    },
    PRIORITY_COLOR_TWO: {
        NONE: 'var(--category-zero-color-2)',
        HIGH: 'var(--category-one-color-2)',
        MEDIUM: 'var(--category-two-color-2)',
        LOW: 'var(--category-three-color-2)'
    },
    PRIORITY_COLOR_THREE: {
        NONE: 'var(--category-zero-color-3)',
        HIGH: 'var(--category-one-color-3)',
        MEDIUM: 'var(--category-two-color-3)',
        LOW: 'var(--category-three-color-3)'
    }
}

export const sideContext = {
    TYPES: {
        CLOSED: 'Closed',
        OPENED: 'Opened',
        POPOUT: 'PopOut'
    }
}

export const tagContext3 = {
    'Dark': {"Default":"#5c5c5c",
        "Paradise Pink":"#ea4861",
        "Medium Violet Red":"#c40879",
        "Electric Purple":"#b14aed",
        "Cornflower Blue":"#5c95ff",
        "Heat Wave":"#f57600",
        "Pistachio":"#90be6d",
        "Zomp":"#43aa8b",
        "Cadet Blue":"#4d908e",
        "Queen Blue":"#577590"},

    'Light': {"Default":"#5c5c5c",
        "Paradise Pink":"#ea4861",
        "Medium Violet Red":"#c40879",
        "Electric Purple":"#b14aed",
        "Cornflower Blue":"#5c95ff",
        "Heat Wave":"#f57600",
        "Pistachio":"#90be6d",
        "Zomp":"#43aa8b",
        "Cadet Blue":"#4d908e",
        "Queen Blue":"#577590"}
}

export const tagContext = {
    'Dark': [
        "#5c5c5c",
        "#ea4861",
        "#c40879",
        "#b14aed",
        "#5c95ff",
        "#f57600",
        "#90be6d",
        "#43aa8b",
        "#4d908e",
        "#577590"
    ],

    'Light': [
        "#5c5c5c",
        "#ea4861",
        "#c40879",
        "#b14aed",
        "#5c95ff",
        "#f57600",
        "#90be6d",
        "#43aa8b",
        "#4d908e",
        "#577590"
    ]
}

export const groupContext = {
    PRIORITY: {title: 'Priority', value: 'PRIORITY', icon:<FaFlag/>},
    TAGS: {title: 'Tags', value: 'TAGS', icon:<FaTags/>},
    START_DATE: {title: 'Start', value: 'START_DATE', icon:<FaCalendarPlus/>},
    DUE_DATE: {title: 'Due', value: 'DUE_DATE', icon:<FaCalendarCheck/>},
}

export const sortContext = {
    PRIORITY: {
        title: 'Priority', value: 'PRIORITY', icon:<FaFlag/>,
        sort: (a,b) => {
            const ref = ['NONE','LOW','MEDIUM','HIGH']
            const ap = ref.indexOf(a['priority'])
            const bp = ref.indexOf(b['priority'])
            const outcome = bp > ap ? 1
                            : bp < ap ? -1
                            : bp === ap ? 0
                            : 0
            return outcome
        }
    },
    DUE_DATE: {
        title: 'Due', value: 'DUE_DATE', icon:<FaCalendarTimes/>,
        sort: (a,b) => {
            let outcome = 0
            if(a['end_date'] || b['end_date']){
                if(!a['end_date']){
                    outcome = 1
                } else if (!b['end_date']){
                    outcome = -1
                } else {
                    const ae = moment(a['end_date'])
                    const be = moment(b['end_date'])
                    if(ae.isAfter(be)){
                        outcome = 1
                    } else if(ae.isSame(be)){
                        outcome = 0
                    } else {
                        outcome = -1
                    }
                }
            } else {
                outcome = 0
            }
            return outcome
        }
    },
    START_DATE: {
        title: 'Start', value: 'START_DATE', icon:<FaCalendarCheck/>,
        sort: (a,b) => {
            let outcome = 0
            if(a['start_date'] || b['start_date']){
                if(!a['start_date']){
                    outcome = 1
                } else if (!b['start_date']){
                    outcome = -1
                } else {
                    const ae = moment(a['start_date'])
                    const be = moment(b['start_date'])
                    if(ae.isAfter(be)){
                        outcome = 1
                    } else if(ae.isSame(be)){
                        outcome = 0
                    } else {
                        outcome = -1
                    }
                }
            } else {
                outcome = 0
            }
            return outcome
        }
    },
    CREATE_DATE: {
        title: 'Created', value: 'CREATE_DATE', icon:<FaCalendarPlus/>,
        sort: (a,b) => {
            let outcome = 0
            if(a['create_date'] || b['create_date']){
                if(!a['create_date']){
                    outcome = 1
                } else if (!b['create_date']){
                    outcome = -1
                } else {
                    const ae = moment(a['create_date'])
                    const be = moment(b['create_date'])
                    if(ae.isAfter(be)){
                        outcome = 1
                    } else if(ae.isSame(be)){
                        outcome = 0
                    } else {
                        outcome = -1
                    }
                }
            } else {
                outcome = 0
            }
            return outcome
        }
    },
    ALPHABETICALLY: {
        title: 'Alphabetically', value: 'ALPHABETICALLY', icon:<FaSortAlphaUp/>,
        sort: (a,b) => {
            let outcome = 0
            const at = getPlainText(a['content'])
            const bt = getPlainText(b['content'])
            if(at > bt){
                outcome = 1
            } else if (at < bt) {
                outcome = -1
            }

            return outcome
        }
    }
}

export const filterContext = {
    PRIORITY: {
        title: 'Priority', value: 'PRIORITY',
        filter: (filter, item) => {
            return filter.includes(item['priority'].toUpperCase())
        }
    },
    TAGS: {
        title: 'Tags', value: 'TAGS',
        filter: (filter, item) => {
            return _.intersection(filter, item['tags']).length > 0
        }
    },
    DATE: {
        title: 'Date', value: 'DATE',
        filter: (filter, item) => {
            if(item['start_date'] && item['end_date']){
                const start = moment(item['start_date']).isSameOrAfter(moment(filter['START_DATE'])) && moment(item['start_date']).isSameOrBefore(moment(filter['END_DATE']))
                const end = moment(item['end_date']).isSameOrAfter(moment(filter['START_DATE'])) && moment(item['end_date']).isSameOrBefore(moment(filter['END_DATE']))
                return start || end
            } else {
                return false
            }
        }
    },
    PAGES: {
        title: 'Pages', value: 'PAGES',
        filter: (filter, item) => {
            return filter.includes(item['pageID'])
        }
    }
}